import React from "react";

import styles from "./FooterBottom.module.css";

const currentYear = () => {
  return new Date().getFullYear();
};

const FooterBottom = () => {
  return (
    <div className={styles.footerBottom}>
      <p>Cleo Childminding 2019 - {currentYear()}</p>
      <p>Created by J.R.</p>
    </div>
  );
};

export default FooterBottom;
